import { FC } from "react";
import { Center, Spinner } from "@chakra-ui/react";

const FullPageSpinner: FC = () => {
  return (
    <Center minH="100vh" h="100%" w="100%">
      <Spinner
        thickness="5px"
        speed="0.65s"
        emptyColor="gray.200"
        color="brand.400"
        size="xl"
      />
    </Center>
  );
};

export default FullPageSpinner;
